export default __webpack_public_path__ + "static/media/jheyms.0c867938.gif";